module.exports = __webpack_public_path__ + "img/黑桃中级大师@2x.2ea7dfae.png";